import { Location } from "react-router-dom";
import { RouteType } from "../@types/RouteType";

export const getMatchingRoute = (routes: RouteType[], currentLocation: Location, dynamicRoute: boolean): RouteType | undefined => {

    let currentLocationPath = currentLocation.pathname;

    /*
        Remove trailing forward slash if exists
    */
    currentLocationPath = currentLocationPath.replace(/\/+$/, ''); 

    if (dynamicRoute) {

        let routeParts = currentLocationPath.split('/');

        /*
            Remove query parameters portion
        */
        routeParts.pop();

        /*
            Combine together to form route with appended /:id
        */

        currentLocationPath = routeParts.join('/') + '/:id';

    }

    for (const route of routes) {

        if (route.path === currentLocationPath) {

            return route;

        }

        if (route.child) {

            for (const routeChild of route.child) {

                if (routeChild.path === currentLocationPath) {

                    return routeChild;

                }

            }

        }

    }

    return undefined;

}